import React from 'react';
import SectionTitle from '../SectionTitle';
import firmImage from './assets/firm.png';
import networkImage from './assets/network.png';
import soloImage from './assets/solo.png';
import styles from './styles.scss';

function HowItWorks () {
  return (
    <div className="mb100">
      <SectionTitle color="#492EFD">
        <h3>IF DESIGNCUE ISN'T RIGHT, TRY THESE OUT ;)</h3>
      </SectionTitle>
      <div className="row">
        <div className={styles.howItWorks}>
          <ul className={`${styles.list} mt50`}>
            <li>
              <div className={styles.image}><img src={firmImage} alt="choose a package" /></div>
              <div className={styles.description}>
                <div className="alt-text demi-bold">
                  <div className={styles.table}>
                    <div className={styles.cell}>
                      DESIGN FIRMS
                    </div>
                  </div>
                </div>
                <div className="bold">
                  <div className={styles.table}>
                    <div className={styles.cell}>
                      $250K+ and no founder control
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div className={styles.image}><img src={networkImage} alt="easy payments" /></div>
              <div className={styles.description}>
                <div className="alt-text demi-bold">
                  <div className={styles.table}>
                    <div className={styles.cell}>
                      FREELANCE NETWORKS
                    </div>
                  </div>
                </div>
                <div className="bold">
                  <div className={styles.table}>
                    <div className={styles.cell}>
                      no project management, extra charges, overseas designers
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div className={styles.image}><img src={soloImage} alt="project manager and designer" /></div>
              <div className={styles.description}>
                <div className="alt-text demi-bold">
                  <div className={styles.table}>
                    <div className={styles.cell}>
                      SOLO-FREELANCERS
                    </div>
                  </div>
                </div>
                <div className="bold">
                  <div className={styles.table}>
                    <div className={styles.cell}>
                      loose deadlines, no vetting, unclear expectations
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default HowItWorks;



// WEBPACK FOOTER //
// ./src/components/OtherOptions/index.js